import type { CanActivate, UrlTree } from '@angular/router';
import type { MustBeAuthorizedGuardConfigInterface } from '@commons/bo-ui/page-unauthorized/must-be-authorized/must-be-authorized.injection-token';
import type { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MUST_BE_AUTHORIZED_GUARD_CONFIG } from '@commons/bo-ui/page-unauthorized/must-be-authorized/must-be-authorized.injection-token';
import { filter, map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MustBeAuthorizedGuard implements CanActivate {
  private readonly mustBeAuthorizedGuardConfig = inject<MustBeAuthorizedGuardConfigInterface>(
    MUST_BE_AUTHORIZED_GUARD_CONFIG
  );

  readonly #router: Router = inject(Router);

  canActivate(): Observable<boolean | UrlTree> {
    if (
      this.mustBeAuthorizedGuardConfig.listAuthorizedRoles === undefined ||
      this.mustBeAuthorizedGuardConfig.listRoles$ === undefined
    ) {
      throw new Error('MUST_BE_AUTHORIZED_GUARD_CONFIG must be configured');
    }

    return this.mustBeAuthorizedGuardConfig.listRoles$.pipe(
      filter((listRoles) => !!listRoles),
      take(1),
      map((listRoles) => {
        if (!this.mustBeAuthorizedGuardConfig.listAuthorizedRoles.some((role) => listRoles.includes(role))) {
          return this.#router.parseUrl(
            this.mustBeAuthorizedGuardConfig.redirectUrl
              ? this.mustBeAuthorizedGuardConfig.redirectUrl
              : '/unauthorized'
          );
        }

        return true;
      })
    );
  }
}
